<div class="table-container simple-hover-table analytics-details-table" #tableContainer>
  <table mat-table matSort [dataSource]="dataSource()" [style.display]="loading() ? 'none' : 'table'">
    <ng-content />

    <tr mat-header-row *matHeaderRowDef="displayedColumns()" class="header-row"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns()"
      class="data-row transition-colors duration-300"
      [id]="'row-' + row.id"
    ></tr>
  </table>

  @if (loading()) {
    <app-skeleton-loader
      containerClass="table-skeleton"
      headerPadding="0 16px 4px 16px"
      headerMargin="4px 0 0 0"
      [columns]="skeletonLoaderTableColumns()"
      [rows]="3"
      [hasAlteringRowBackgroundColor]="false"
      [showColumns]="true"
      [showPaginator]="false"
    />
  }

  @if (!loading() && dataSource().data.length === 0) {
    <div class="text-center font-bold text-shikenso-purple-base-60">
      {{ 'components.analyticsDetailsTable.noFindings' | translate }}
    </div>
  }
</div>
